<template>
    <div>
        <span>
            <font-awesome-icon icon="far fa-location" />
        </span>

        <span v-if="!multilocation">
            {{ vehicleLocation }}
        </span>

        <span v-else>
            {{ $t('general.multilocations') }}
        </span>
    </div>
</template>

<script>
export default {
    name: "Location",
    props: {
        vehicleLocation: {
            type: String
        },
        multilocation: {
            type: Number,
            default: 0
        }
    },
}
</script>
